var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoewenmutLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "#F4DD01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3623 22.307H10.2773V7.62598H12.5833V20H16.3583L16.3623 22.307Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7213 21.1959C19.7231 21.4691 19.6301 21.7344 19.4581 21.9467C19.2861 22.1589 19.0457 22.3049 18.7781 22.3597C18.5105 22.4145 18.2321 22.3748 17.9905 22.2472C17.7489 22.1197 17.559 21.9123 17.4533 21.6604C17.3476 21.4085 17.3325 21.1277 17.4107 20.866C17.4889 20.6042 17.6555 20.3777 17.882 20.2251C18.1086 20.0724 18.3811 20.0031 18.6531 20.029C18.925 20.0549 19.1796 20.1743 19.3733 20.3669C19.4849 20.474 19.5733 20.6028 19.6331 20.7454C19.693 20.8879 19.723 21.0413 19.7213 21.1959Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoewenmutLogo);
export default __webpack_public_path__ + "static/media/loewenmut-logo.918481b577f05a8f8b069b7b8ed174c0.svg";
export { ForwardRef as ReactComponent };